import { node, icon } from "~/util/dom";
import { NOTIFICATIONS_TYPE } from "~/util/notifications";

export interface INotificationItem {
	container: HTMLLIElement;
	id: number;
	type: NOTIFICATIONS_TYPE;
}

const TYPES = [{
	icon: "check",
	className: "info",
}, {
	icon: "alert",
	className: "error",
}, {
	icon: "question",
	className: "question",
}, {
	icon: "info",
	className: "info",
}];

export function createNotificationItem(data, callback): INotificationItem {
	const id = Math.random();
	const type = data.type;
	const container = node("li", { className: TYPES[data.type].className });

	container.appendChild(icon(TYPES[data.type].icon));

	// samotny obsah
	const content = node("div", { className: "content" });

	if (typeof data.content === "string") {
		content.textContent = data.content;
	} else {
		content.appendChild(data.content);
	}

	container.appendChild(content);

	// pokud existuje extra akce, tak ji vlozime
	if (data.action) {
		const action = node("div", { className: "action" });

		action.appendChild(data.action);
		container.appendChild(action);
	}

	const item = {
		container,
		id,
		type,
	};

	// nezavre se to samo
	if (data.type !== NOTIFICATIONS_TYPE.INFO && !data.noClose) {
		const closeButton = node("button", { type: "button" });

		closeButton.appendChild(icon("close"));

		closeButton.addEventListener("click", () => {
			callback && callback(item);
		}, false);

		container.appendChild(closeButton);
	}

	return item;
}
